import AuthService from '../../services/AuthService';
import jwt_decode from "jwt-decode";

export function login ({ commit }, user) {
  return AuthService.login(user)
    .then(response => {
      if (response.data.access_token) {
        const token = response.data.access_token
        const decoded = jwt_decode(token)

        commit('setToken', {
          token: token
        })

        commit('setUser', {
          authorities: decoded.authorities,
          name: decoded.user_name,
        })
      }

      return Promise.resolve()
    })
    .catch(e => {
      return Promise.reject(e)
    })
}

export function loginD4H () {
}

export function logout (state) {
  AuthService.logout()
  state.commit('setUser', null)
  state.commit('setToken', null)
}

export function logoutD4H ({ commit }) {
  AuthService.logout()
  commit('setTokenD4HToken', null)
}

